import * as React from 'react';
import { ISignInState } from '@apps-config/login-state';
import { isInternationalUser } from '@telstra-connect/login/methods/customer-type';
import { useSelector } from 'react-redux';
import { FeatureFlagNames, useBvtFlagsChecker } from '@utils/bvt-feature-flags';
import OrderListNew from '../pages/order-list-new/index-lazy';
import UnifiedTrackView from '../pages/unified-track-view/index-lazy';
import OrderTrackerInt from '../pages/order-tracker-int/index-lazy';
import { getFlags } from '@telstra-connect/order-tracker/feature-flags';

const UnifiedTrackViewWrapper = () => {
    const signInState: ISignInState = useSelector((state: ISignInState) => state);
    const isInternationalCustomer = isInternationalUser(signInState);
    const { isBvtFlagEnabled } = useBvtFlagsChecker({ bvtFlagName: FeatureFlagNames.tedig3007OrderListChanges })
    const orderTrackerIntUIUpliftment  = getFlags().orderTrackerIntUIUpliftment;
    return (
        <React.Fragment>
            {isBvtFlagEnabled && !isInternationalCustomer ? (
                <OrderListNew />
            ) :
               orderTrackerIntUIUpliftment ? (<OrderTrackerInt/>) :  (<UnifiedTrackView signInState={signInState}/>)
            }
        </React.Fragment>
    );
};

export default UnifiedTrackViewWrapper;
